export const MODULE_PERMISSION_KEYS = [
  'dashboard',
  'leads',
  'customers',
  'quotations',
  'orders',
  'kots',
  'deliveries',
  'invoices',
  'payment_reminders',
  'payments',
  'products',
  'website',
  'reports',
  'users',
  'settings',
  'commercial_context',
];

export const MODULE_PERMISSION_LABELS = {
  dashboard: 'Dashboard',
  leads: 'Contacts',
  customers: 'Customers',
  quotations: 'Quotations',
  orders: 'Orders',
  kots: 'KOT',
  deliveries: 'Delivery',
  invoices: 'Invoices',
  payment_reminders: 'Payment Reminders',
  payments: 'Payments',
  products: 'Products',
  website: 'Storefronts / CMS',
  reports: 'Reports',
  users: 'Users',
  settings: 'Settings',
  commercial_context: 'Business Structure',
};

export const MODULE_DEFAULT_ROUTES = {
  dashboard: '/dashboard',
  leads: '/leads',
  quotations: '/quotations',
  orders: '/orders',
  kots: '/kots',
  deliveries: '/deliveries',
  invoices: '/invoices',
  payment_reminders: '/payment-reminders',
  payments: '/payments',
  products: '/products/list',
  website: '/storefronts',
  reports: '/reports',
  users: '/users',
  settings: '/settings',
  customers: '/customers',
  commercial_context: '/commercial-context',
};

export const getDefaultModulePermissions = () => {
  return MODULE_PERMISSION_KEYS.reduce((acc, key) => {
    acc[key] = true;
    return acc;
  }, {});
};

export const normalizeModulePermissions = (permissions) => {
  const defaults = getDefaultModulePermissions();

  if (!permissions || typeof permissions !== 'object') {
    return defaults;
  }

  return MODULE_PERMISSION_KEYS.reduce((acc, key) => {
    if (key === 'orders') {
      if (Object.prototype.hasOwnProperty.call(permissions, 'orders')) acc[key] = Boolean(permissions.orders);
      else if (Object.prototype.hasOwnProperty.call(permissions, 'work_orders')) acc[key] = Boolean(permissions.work_orders);
      else acc[key] = defaults[key];
      return acc;
    }
    acc[key] = Object.prototype.hasOwnProperty.call(permissions, key)
      ? Boolean(permissions[key])
      : defaults[key];
    return acc;
  }, {});
};

export const getFirstAccessibleModuleRoute = (permissions) => {
  const normalized = normalizeModulePermissions(permissions);

  for (const key of MODULE_PERMISSION_KEYS) {
    if (normalized[key]) {
      return MODULE_DEFAULT_ROUTES[key] || '/dashboard';
    }
  }

  return '/dashboard';
};
